import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { localizeApiDetail } from '../../i18n/apiError'
import { leadsAPI } from './api'
import type { LeadCategory } from './api'

export default function KategorierTab() {
  const { t } = useTranslation('leads')
  const [categories, setCategories] = useState<LeadCategory[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    setLoading(true)
    leadsAPI.getCategories()
      .then(res => setCategories(res.data))
      .catch(err => setError(localizeApiDetail(err.response?.data?.detail) || err.message))
      .finally(() => setLoading(false))
  }, [])

  if (error) return <div className="card p-6 text-red-600 dark:text-red-400">{error}</div>
  if (loading) return <div className="card p-6 animate-pulse h-40 bg-gray-100 dark:bg-dark-border rounded-sm" />

  return (
    <div className="card p-6">
      <div className="overflow-x-auto">
        <table className="data-table data-table-compact">
          <thead>
            <tr>
              <th className="text-left">{t('kategorier.kode')}</th>
              <th className="text-left">{t('kategorier.navn')}</th>
              <th className="text-center">{t('kategorier.niva')}</th>
              <th className="text-right">{t('kategorier.prioritet')}</th>
              <th className="text-right">{t('common.score')}</th>
              <th className="text-right">{t('kategorier.ttl')}</th>
            </tr>
          </thead>
          <tbody>
            {categories.map((c, idx) => (
              <tr key={c.code} className={idx % 2 === 0 ? 'bg-gray-50 dark:bg-gray-800/30' : ''}>
                <td className="font-mono text-xs">{c.code}</td>
                <td className="font-bold">{c.name}</td>
                <td className="text-center">
                  <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs ${
                    c.lead_level === 'car'
                      ? 'bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300'
                      : 'bg-purple-100 dark:bg-purple-900/30 text-purple-800 dark:text-purple-300'
                  }`}>
                    {c.lead_level}
                  </span>
                </td>
                <td className="text-right">{c.priority}</td>
                <td className="text-right font-bold">{c.lead_score}</td>
                <td className="text-right">{c.ttl_days}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
